export const serviceLabels: Record<string, string> = {
  valet: "Valet",
  selfParking: "Self Parking",
  golfCar: "Golf Cart",
  partialCarWash: "Partial Car Wash",
  fullCarWash: "Complete Car Wash",
};

export const locationServices = [
  "valet",
  "selfParking",
  "golfCar",
  "partialCarWash",
  "fullCarWash",
];
